import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { FnCallPipe } from '@core/common-legacy';
import type { IconName } from '@core/user-interface-legacy';
import { IconComponent } from '@core/user-interface-legacy';
import { kebabCase } from '@core/utils-legacy';

import { EmojiComponent } from '../emoji/emoji.component';
import { IconFontComponent } from '../icon-font/icon-font.component';
import type { AnySymbol } from '../symbol.types';

@Component({
  selector: 'rt-symbol',
  imports: [EmojiComponent, IconComponent, IconFontComponent, FnCallPipe],
  templateUrl: './symbol.component.html',
  styleUrls: ['./symbol.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.is-svg]': 'displaySymbol()?.type === "svg"',
  },
})
export class SymbolComponent {
  private readonly domSanitizer = inject(DomSanitizer);

  public symbol = input.required<AnySymbol | null>();
  public fallbackSymbol = input<AnySymbol>();
  public fallbackIcon = input<IconName>();
  public forceFallback = input<boolean>(false);

  public displaySymbol = computed(
    (): AnySymbol | null => this.symbol() ?? this.fallbackSymbol() ?? null,
  );

  protected kebabCase = kebabCase;
  // eslint-disable-next-line ban/ban
  protected trustHtml = (content: string) => this.domSanitizer.bypassSecurityTrustHtml(content);
}
